import { defineMessage } from '../../../../../services/localization';

export const messages = {
    advanced: defineMessage('advanced'),
    premium: defineMessage('premium'),
    featuresExcludedNote: defineMessage('the_features_below_are__t_included_in_the_trial'),
    allAdvancedFeatures: defineMessage('all_advanced_features'),
    addOnsTitle: defineMessage('addons'),
};
